import { CognitoUserPool } from 'amazon-cognito-identity-js';

export default new CognitoUserPool({
  ClientId: process.env.REACT_APP_AWS_CLIENT_ID as string,
  UserPoolId: process.env.REACT_APP_AWS_USER_POOL_ID as string,
});
